import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { logService } from 'services/api/LogService';

export const MovementVersionDialog = ({
  open,
  onClose,
  versionId
}: {
  open: boolean;
  onClose: () => void;
  versionId: number;
}) => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.versions.detail';
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => {
    if (!open) return;

    logService.get(`/${versionId}/`).then((res) => {
      if (res.full_object) {
        const newRows = Object.entries(res.full_object).map(([field, value], id) => {
          const displayValue =
            typeof value === 'object' && value !== null ? JSON.stringify(value) : value;

          return {
            id,
            field: t(`pages.versions.entities.${res.model_name}.${field}`),
            value: displayValue
          };
        });

        setRows(newRows);
      }
    });
  }, [open, versionId]);

  const columns: GridColDef[] = [
    {
      field: 'field',
      headerName: t(`global.field`),
      flex: 1
    },
    {
      field: 'value',
      headerName: t(`global.value`),
      flex: 2
    }
  ];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
      <DialogTitle>
        {t(`${translationPrefix}.title`)} {versionId}
      </DialogTitle>
      <DialogContent>
        <div style={{ height: 400, width: '100%' }}>
          <DataGridPremium rows={rows} columns={columns} disableSelectionOnClick />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('global.cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default MovementVersionDialog;
